import { useState } from "react";
import { MapPin, Phone, MessageCircle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

export const STUDIO = {
  name: "Warna Borneo",
  lines: ["Lot 144, Donggongon 2", "Donggongon Newtownship", "89507 Penampang, Sabah, Malaysia"],
  phone: "+6019-8806073",
  tel: "tel:+60198806073",
  wa: "https://wa.me/60198806073",
};

const EMPTY = { name: "", email: "", subject: "", message: "" };

function ContactForm() {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post("/contact", f); setSent(true); setF(EMPTY); toast.success("Message sent — thank you!"); }
    catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  if (sent)
    return (
      <div className="wb-card p-10" data-testid="contact-success">
        <CheckCircle2 className="gold" size={28} />
        <h2 className="mt-5 font-display text-3xl">Thank you for writing.</h2>
        <p className="mt-3 text-sm muted">Your message has reached the studio. We usually reply within two working days.</p>
        <button onClick={() => setSent(false)} className="btn-ghost mt-8" data-testid="contact-send-another">Send another message</button>
      </div>
    );
  return (
    <form onSubmit={submit} className="wb-card p-8 md:p-10 space-y-5" data-testid="contact-form">
      <div className="grid gap-5 sm:grid-cols-2">
        <div><label className="wb-label">Name *</label><input required className="wb-input" value={f.name} onChange={set("name")} data-testid="contact-name-input" /></div>
        <div><label className="wb-label">Email *</label><input required type="email" className="wb-input" value={f.email} onChange={set("email")} data-testid="contact-email-input" /></div>
      </div>
      <div><label className="wb-label">Subject *</label><input required className="wb-input" value={f.subject} onChange={set("subject")} data-testid="contact-subject-input" /></div>
      <div><label className="wb-label">Message *</label><textarea required rows={6} className="wb-input" value={f.message} onChange={set("message")} data-testid="contact-message-input" /></div>
      {err && <p className="text-sm text-red-400" data-testid="contact-error">{err}</p>}
      <button disabled={busy} className="btn-gold" data-testid="contact-submit-button">{busy ? "Sending…" : "Send message"}</button>
    </form>
  );
}

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Contact" title="Commissions & enquiries">
        For commissions, exhibitions, shipping questions or simply to say hello — write to the studio or reach us directly.
      </PageHeader>
      <div className="wb-container grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7"><ContactForm /></div>
        <aside className="lg:col-span-5 space-y-8">
          <div className="wb-card p-8" data-testid="contact-details">
            <div className="flex gap-4">
              <MapPin size={18} className="gold mt-1 shrink-0" />
              <address className="not-italic text-sm leading-relaxed" data-testid="contact-address">
                <span className="font-display text-xl">{STUDIO.name}</span><br />
                {STUDIO.lines.map((l) => <span key={l}>{l}<br /></span>)}
              </address>
            </div>
            <div className="mt-6 flex gap-4">
              <Phone size={18} className="gold shrink-0" />
              <a href={STUDIO.tel} className="text-sm hover:text-wb-gold transition-colors" data-testid="contact-phone-link">{STUDIO.phone}</a>
            </div>
            <a href={STUDIO.wa} target="_blank" rel="noreferrer" className="btn-ghost mt-8 w-full" data-testid="contact-whatsapp-link">
              <MessageCircle size={14} /> Chat on WhatsApp
            </a>
          </div>
          <div className="art-frame aspect-[4/3] border wb-line">
            <iframe
              title="Warna Borneo location — Donggongon, Penampang"
              src="https://maps.google.com/maps?q=Donggongon%20Newtownship%2C%20Penampang%2C%20Sabah%2C%20Malaysia&z=15&output=embed"
              className="h-full w-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map"
            />
          </div>
        </aside>
      </div>
    </div>
  );
}
